import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { mergeStyleProps } from '../../../util/mergeStyleProps.js';
import '../../../util/styles/index.js';
import { useEnterExitAnimation } from '../../../util/useEnterExitAnimation.js';
import { usePopover } from '@react-aria/overlays';
import { useAdsStyles } from '../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["state", "width", "minWidth", "maxWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useAriaPopover = function useAriaPopover(props) {
  var state = props.state,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    rest = _objectWithoutProperties(props, _excluded);
  var popoverRef = React.useRef(null);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _usePopover = usePopover(_objectSpread(_objectSpread({}, rest), {}, {
      popoverRef: popoverRef
    }), state),
    popoverProps = _usePopover.popoverProps,
    underlayProps = _usePopover.underlayProps;
  var popoverStyle = mapAdsStyles({
    width: width && width > '0' ? width : 'auto',
    minWidth: minWidth && minWidth > '0' ? minWidth : '180px',
    maxWidth: maxWidth && maxWidth > '0' ? maxWidth : 'auto',
    borderRadius: {
      value: '8'
    },
    boxShadow: 'bottom-m',
    overflow: 'auto',
    backgroundColor: 'base.surface',
    p: '8'
  });
  var _useEnterExitAnimatio = useEnterExitAnimation({
      initialProps: {
        opacity: 0
      },
      enterProps: {
        opacity: 1
      },
      animationOn: state.isOpen,
      transition: '300ms ease-in-out',
      animationFallBackTimeMs: 300
    }),
    transitionProps = _useEnterExitAnimatio.transitionProps,
    shouldRender = _useEnterExitAnimatio.shouldRender;
  return {
    underlayProps: underlayProps,
    popoverProps: mergeStyleProps(popoverProps, popoverStyle),
    popoverRef: popoverRef,
    transitionProps: transitionProps,
    shouldRender: shouldRender
  };
};

export { useAriaPopover };
//# sourceMappingURL=useAriaPopover.js.map
